import { render, staticRenderFns } from "./ProductArtworkVersionsModal.vue?vue&type=template&id=14bd0fe3&scoped=true&"
import script from "./ProductArtworkVersionsModal.vue?vue&type=script&lang=js&"
export * from "./ProductArtworkVersionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bd0fe3",
  null
  
)

export default component.exports